import { render, staticRenderFns } from "./RoyaltyTransactionTable.vue?vue&type=template&id=2dd1c756&scoped=true&"
import script from "./RoyaltyTransactionTable.vue?vue&type=script&lang=js&"
export * from "./RoyaltyTransactionTable.vue?vue&type=script&lang=js&"
import style0 from "./RoyaltyTransactionTable.vue?vue&type=style&index=0&id=2dd1c756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd1c756",
  null
  
)

export default component.exports